import { Reducer, Action } from 'redux';
import {
    NextConversationState,
    NextConvoError
}                          from '../../reduxTypes';
import ActionTypes         from '../../ActionTypes';

interface LoadNextConvoIdAction extends Action {
    conversationId: number;
    callListId: number;
    activityType: string;
}

interface LoadNextConvoErrorAction extends Action {
    error: NextConvoError;
}

interface SmartListStatusAction extends Action {
    hasSmartList: boolean;
}

export const defaultState: NextConversationState = {
    loading: false,
    hasSmartList: false
};

const NextConversationReducer: Reducer<NextConversationState> = (state: NextConversationState = defaultState, action: Action): NextConversationState => {
    const loadNextConvoAction      = action as LoadNextConvoIdAction;
    const loadNextConvoErrorAction = action as LoadNextConvoErrorAction;

    switch (action.type) {
        case ActionTypes.NEXT_CONVO_LOADING:
            return {
                ...state,
                loading: true
            };

        case ActionTypes.NEXT_CONVO_LOADING_ERROR:
            return {
                ...state,
                loading: false,
                error: loadNextConvoErrorAction.error
            };

        case ActionTypes.NEXT_CONVO_ID_LOADED:
            return {
                ...state,
                conversationId: loadNextConvoAction.conversationId,
                callListId: loadNextConvoAction.callListId,
                activityType: loadNextConvoAction.activityType
            };

        case ActionTypes.NEXT_CONVO_LOADED:
            return {
                ...state,
                loading: false
            };

        case ActionTypes.SMART_LIST_STATUS_LOADED:
            return {
                ...state,
                hasSmartList: (action as SmartListStatusAction).hasSmartList
            };

        case ActionTypes.SMART_LIST_STATUS_ERROR:
            return {
                ...state,
                error: loadNextConvoErrorAction.error
            };

        default:
            return state;
    }
};

export default NextConversationReducer;



// WEBPACK FOOTER //
// ./src/sections/NextConversation/NextConversationReducer.ts